import {  put, takeEvery } from 'redux-saga/effects'
import {loadingStart, loadingStop} from '../action'
import {push} from 'react-router-redux'
import {getFirebase} from 'react-redux-firebase'



function* deleteJob(payload) {
    //console.log('---------------DELETE JOB----------------')
    let jobs = payload.jobs
    jobs[payload.jobId] = null
    getFirebase().updateProfile({jobs: jobs})
}

function* addJob(payload) {
    //console.log(payload)
    yield put(loadingStart("เพิ่มสาขาวิชาที่สนใจ..."))
    let score = {
        COG: 0,
        CPN: 0,
        LOM: 0,
        PCS: 0,
        PEW: 0,
        PIS: 0,
        PPM: 0,
        SMC: 0,
        WCEO: 0,
        WCII: 0,
        WIAM: 0,
        WICH: 0,
        WPAM: 0,
        WPPM: 0
    }
    //const n = Object.keys(payload.jobs).length
    const n=1
    const j = 0
    //for(let j in Object.keys(payload.jobs)) {
        const jobName = payload.jobs[j].jobENG
        getFirebase().ref(`jobs/${jobName}`).once('value').then((snapshot) => {
            let wpMean = 0, ssMean = 0
            score.COG += snapshot.val().COG/n
            
            //SS
            score.CPN += snapshot.val().CPN/n
            ssMean += snapshot.val().CPN/n

            score.LOM += snapshot.val().LOM/n
            ssMean += snapshot.val().LOM/n

            score.PCS += snapshot.val().PCS/n
            ssMean += snapshot.val().PCS/n

            score.PEW += snapshot.val().PEW/n
            ssMean += snapshot.val().PEW/n

            score.PIS += snapshot.val().PIS/n
            ssMean += snapshot.val().PIS/n

            score.PPM += snapshot.val().PPM/n
            ssMean += snapshot.val().PPM/n

            score.SMC += snapshot.val().SMC/n
            ssMean += snapshot.val().SMC/n

            ssMean /= 7
            let ssSD = 
                Math.pow(score.CPN-ssMean,2) + 
                Math.pow(score.LOM-ssMean,2) + 
                Math.pow(score.PCS-ssMean,2) + 
                Math.pow(score.PEW-ssMean,2) + 
                Math.pow(score.PIS-ssMean,2) + 
                Math.pow(score.PPM-ssMean,2) + 
                Math.pow(score.SMC-ssMean,2) 
            ssSD = Math.sqrt(ssSD/(7-1))
            score.ZCPN = (score.CPN - ssMean)/ssSD
            score.ZLOM = (score.LOM - ssMean)/ssSD
            score.ZPCS = (score.PCS - ssMean)/ssSD
            score.ZPEW = (score.PEW - ssMean)/ssSD
            score.ZPIS = (score.PIS - ssMean)/ssSD
            score.ZPPM = (score.PPM - ssMean)/ssSD
            score.ZSMC = (score.SMC- ssMean)/ssSD
            ///--------WP
            score.WCEO += snapshot.val().WCEO/n
            wpMean += snapshot.val().WCEO/n

            score.WCII += snapshot.val().WCII/n
            wpMean += snapshot.val().WCII/n

            score.WIAM += snapshot.val().WIAM/n
            wpMean += snapshot.val().WIAM/n

            score.WICH += snapshot.val().WICH/n
            wpMean += snapshot.val().WICH/n

            score.WPAM += snapshot.val().WPAM/n
            wpMean += snapshot.val().WPAM/n

            score.WPPM += snapshot.val().WPPM/n
            wpMean += snapshot.val().WPPM/n

            wpMean /= 6
            let wpSD = 
                Math.pow(score.WCEO-wpMean,2) + 
                Math.pow(score.WCII-wpMean,2) + 
                Math.pow(score.WIAM-wpMean,2) + 
                Math.pow(score.WICH-wpMean,2) + 
                Math.pow(score.WPAM-wpMean,2) + 
                Math.pow(score.WPPM-wpMean,2) 
                
            wpSD = Math.sqrt(wpSD/(6-1))
            score.ZWCEO = (score.WCEO - wpMean)/wpSD
            score.ZWCII = (score.WCII - wpMean)/wpSD
            score.ZWIAM = (score.WIAM - wpMean)/wpSD
            score.ZWICH = (score.WICH - wpMean)/wpSD
            score.ZWPAM = (score.WPAM - wpMean)/wpSD
            score.ZWPPM = (score.WPPM - wpMean)/wpSD

            score.Zextraversion = 0.60465996
            score.Zagreeableness = 0.519496586
            score.Zconscientiousness = 0.77498671
            score.ZdesireToLearn = 0.264006462
            score.Zmastery = -0.076647037
            score.ZotherReferencedGoals = -1.354097657
            score.Zcompetitiveness = -0.161810412
            score.Zworry = -1.524424407
            score.Zemotionality = -0.757954035
            score.ZselfEfficacy = 1.711783831

            score.ZCOG = ((2-(-2))*((score.COG-0)/(100-0))) + (-2)
            if(parseInt(j) +1 === n ) {
                try{
                    const jobs = {
                        university: payload.university,
                        faculty: payload.faculty,
                        department: payload.department,
                        selectedJobs: payload.jobs,
                        image: payload.image,
                        score: score,
                        name: payload.name
                    }
                    let temp = {}
                    if(payload.oldJobs) {
                        temp = payload.oldJobs
                    }
                    const id = Date.now()
                    temp[id] = jobs
                    getFirebase().updateProfile({jobs: temp})
                    
                } catch(err) {
                    console.log('-----SAGA ERROR-----', err)
                }
            }
        })
    //}
    yield put(loadingStop())
    yield put(push('/'))
}
export default function* JobSearchSaga() {
    yield takeEvery('@@jobSearch/ADD', addJob)
    yield takeEvery('@@jobSearch/DELETE', deleteJob)
}



// WEBPACK FOOTER //
// ./src/search/saga.js